import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';

import {
  DependencyQuery,
  useDependencyLazyQuery,
} from '@/components/common/Providers/GraphqlProvider/generated';

interface IUseGetDependencyById {
  dependencyId: string;
  options?: Omit<
    UndefinedInitialDataOptions<
      DependencyQuery | undefined,
      Error,
      DependencyQuery | undefined,
      string[]
    >,
    'queryKey' | 'queryFn'
  >;
}

export const useGetDependencyById = ({ dependencyId, options }: IUseGetDependencyById) => {
  const [getDependencyById] = useDependencyLazyQuery();

  const queryData = useQuery({
    queryKey: ['dependencyById', dependencyId],
    queryFn: async () => {
      const { data } = await getDependencyById({
        variables: {
          dependencyId,
        },
        fetchPolicy: 'no-cache',
        nextFetchPolicy: 'no-cache',
      });

      return data;
    },
    enabled: options?.enabled || !!dependencyId,
    ...options,
  });

  return queryData;
};
